import $ from 'jquery';
import { debounce } from 'underscore';
import adTagBuilder from './jwplayer-infinite-scroll-ads';
import Autoplay from './jwplayer-infinite-scroll-autoplay';
import 'slick-carousel';

class JWPlayerInit {
    constructor() {
        this.chartbeat = window._cbv || [];
        this.moduleTitle = null;
        this.buttonClass = null;
        this.$playlistWrapper = null;
        this.$titleWrapper = null;
        this.adTag = adTagBuilder.adUrl;
        this.player = {};
        this.options = {
            playlist: `//content.jwplatform.com/feeds/${this.determinePlaylist()}`,
            advertising: {
                client: 'googima',
                tag: this.adTag
            },
            ga: {},
            mute: true
        };
        this.slickConfig = {
            prevArrow: '',
            nextArrow: '',
            responsive: [{
                breakpoint: 99999,
                settings: "unslick"
            }, {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 5.75,
                    slidesToScroll: 5,
                    infinite: false,
                    slide: '.video-module__up-next'
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 2,
                    infinite: false,
                    slide: '.video-module__up-next'
                }
            }]
        };
    }

    determinePlaylist() {
        var currentURL = window.location.href;
        if (/fastcompany/.test(currentURL)) {
            this.buttonClass = "background-theme-button--brand";
            this.moduleTitle = "Fast Company Videos";
            return 'R6of2m4z.json';
        }
        if (/fastcodesign/.test(currentURL)) {
            this.buttonClass = "background-theme-button--design";
            this.moduleTitle = "Co.Design Videos";
            return 'mQZdMNHq.json';
        }
        if (/fastcocreate/.test(currentURL)) {
            this.buttonClass = "background-theme-button--create";
            this.moduleTitle = "Co.Create Videos";
            return 'Z9wjc6DM.json';
        }
        if (/fastcoexist/.test(currentURL)) {
            this.buttonClass = "background-theme-button--exist";
            this.moduleTitle = "Co.Exist Videos";
            return '4PYo5Vtn.json';
        }
    }

    initPlayer() {
        this.player.setup(this.options);

        this.player.on('ready', function () {
            var autoplay = new Autoplay(this.player);
            autoplay.on();
            this.customizeBranding();
            this.$playlistWrapper = $('.video-module__up-next-list');
            this.$titleWrapper = $('.video-module__video-title');
            this.buildPlaylistSidebar(this.player.getPlaylist());
            this.chartbeat.push(this.player);
        }.bind(this));

        this.player.on('playlistItem', function () {
            this.updateTitle();
            this.chartbeat.push(this.player);
        }.bind(this));
    }

    buildPlaylistSidebar(playlist) {
        for (var i = 0; i < playlist.length; i++) {
            this.$playlistWrapper.append(
                `<li data-index=${i} class="video-module__up-next card-hover-effect">
                    <figure data-index=${i} class="video-module__up-next__article__figure">
                        <img data-index=${i} src=${playlist[i].image} />
                     </figure>
                    <span data-index=${i} class="video-module__up-next-title">${playlist[i].title}</span>
                </li>`
            );
        }

        $('.video-module__up-next').click(function (e) {
            this.player.playlistItem($(e.target).data('index'));
        }.bind(this));

        this.updateSlick();
    }

    updateTitle() {
        var video = this.player.getPlaylistItem();
        $('.video-module__up-next__article__figure--playing').removeClass('video-module__up-next__article__figure--playing');
        $(`figure[data-index=${video.index ? video.index : 0}]`).addClass('video-module__up-next__article__figure--playing');
        this.$titleWrapper.text(video.title);
    }

    updateSlick() {
        if ($(window).width() > 1023) {
            if (this.$playlistWrapper.hasClass('slick-initialized')) {
                this.$playlistWrapper.slick('unslick');
            }
            return;
        }

        if (!this.$playlistWrapper.hasClass('slick-initialized')) {
            return this.$playlistWrapper.slick(this.slickConfig);
        }
    }

    customizeBranding() {
        $('.videos-most-pop-wrapper__title').text(this.moduleTitle);
        $('.background-theme-button--video-infinite-scroll').addClass(this.buttonClass);
    }

    on() {
        $.getScript(`//content.jwplatform.com/libraries/MyQ2uJQ0.js`, function () {
            this.player = jwplayer('videos-most-pop-wrapper__player');
            this.initPlayer();
        }.bind(this));

        $(window).on('resize', debounce(this.updateSlick.bind(this), 300));
    }

    off() {
        this.player = {};
    }
}

export default new JWPlayerInit();
